import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Lotdetrois = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.88 105.55">
  <G fill={color}>
    <Polygon points="8.89 18.58 3.36 18.58 3.36 .25 0 .25 0 21.64 8.89 21.64 8.89 18.58"/>
    <Path d="M15.19,21.88c1.65,0,2.91-.46,3.79-1.39.88-.93,1.31-2.26,1.31-3.99V5.38c0-1.73-.44-3.06-1.31-3.99-.88-.93-2.14-1.39-3.79-1.39s-2.91.46-3.79,1.39c-.88.93-1.31,2.26-1.31,3.99v11.12c0,1.73.44,3.06,1.31,3.99.88.93,2.14,1.39,3.79,1.39ZM13.45,5.17c0-.77.16-1.32.47-1.63s.74-.47,1.27-.47.95.16,1.27.47.47.86.47,1.63v11.55c0,.77-.16,1.32-.47,1.64s-.74.47-1.27.47-.95-.16-1.27-.47-.47-.86-.47-1.64V5.17Z"/>
    <Polygon points="21.48 .25 21.48 3.3 25 3.3 25 21.64 28.36 21.64 28.36 3.3 31.88 3.3 31.88 .25 21.48 .25"/>
    <Path d="M14.59,37.87c.46-.5.69-1.23.69-2.19v-6.01c0-.96-.23-1.69-.69-2.19s-1.16-.75-2.1-.75h-2.96v11.89h2.96c.94,0,1.64-.25,2.1-.75ZM11.41,36.92v-8.49h1.05c.29,0,.53.08.7.25s.25.47.25.9v6.18c0,.43-.08.73-.25.9-.17.17-.4.25-.7.25h-1.05Z"/>
    <Polygon points="21.56 28.43 21.56 26.73 16.47 26.73 16.47 38.62 21.56 38.62 21.56 36.92 18.34 36.92 18.34 33.44 20.9 33.44 20.9 31.74 18.34 31.74 18.34 28.43 21.56 28.43"/>
    <Path d="M15.45,42.33c-4.77,0-8.37,1.34-10.82,4.02-2.44,2.68-3.66,6.52-3.66,11.52v3.36h9.18v-3.97c0-2.24.46-3.81,1.37-4.72s2.13-1.37,3.66-1.37,2.75.49,3.66,1.46c.91.97,1.37,2.84,1.37,5.61v3.44c0,2.47-.52,4.18-1.55,5.12-1.03.94-2.46,1.41-4.28,1.41h-3.8v8.83h3.27c2.24,0,3.85.59,4.86,1.77,1,1.18,1.5,3.21,1.5,6.09v4.86c0,2.77-.46,4.62-1.37,5.56-.91.94-2.13,1.41-3.66,1.41s-2.75-.46-3.66-1.37c-.91-.91-1.37-2.49-1.37-4.72v-5.74H.97v5.12c0,5,1.22,8.84,3.66,11.52,2.44,2.68,6.05,4.02,10.82,4.02s8.37-1.34,10.82-4.02c2.44-2.68,3.66-6.52,3.66-11.52v-4.86c0-3.18-.52-5.87-1.54-8.08-1.03-2.21-2.78-3.84-5.25-4.9,4.53-1.88,6.8-6.12,6.8-12.71v-1.59c0-5-1.22-8.84-3.66-11.52-2.44-2.68-6.05-4.02-10.82-4.02Z"/>
  </G>
</Svg>
);
};

export default Lotdetrois;
